import Vue from "vue";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import AsyncComputed from "vue-async-computed";
import VueTheMask from "vue-the-mask";
import VeeValidate from "vee-validate";
// import VueAnalytics from 'vue-analytics';
import VueNumerals from "vue-numerals";
import VueFuse from "vue-fuse";
import VCalendar from "v-calendar";
import Hotjar from "vue-hotjar";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import routes from "~/routes/routes";
import store from "~/store/store";
import GlobalComponents from "~/globalComponents.js";
import dictionary from "~/components/Validators/dictionary.js";
import dayjs from "dayjs";
import vueDayjs from "vue-dayjs";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/pt-br";
import katex from "katex";
import "katex/dist/katex.min.css";
import socketio from "socket.io-client";
import VueSocketIO from "vue-socket.io";

import App from "./App";

const connectionOptions = {
  "force new connection": true,
  reconnectionAttempts: "Infinity",
  timeout: 10000,
  transports: ["websocket", "polling"],
  closeOnBeforeunload: false
};

window.katex = katex;

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(AsyncComputed);
Vue.use(VueTheMask);
Vue.use(GlobalComponents);
Vue.use(VueFuse);
Vue.use(VCalendar);

Vue.use(vueDayjs, {
  lang: "en",
  filters: { ago: "ago" },
  directives: { countdown: "countdown" }
});

Vue.use(VueNumerals, {
  locale: "pt-br"
});

dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("America/Sao_Paulo");
dayjs.locale("pt-br");

const config = {
  dictionary,
  inject: false,
  locale: "pt_BR"
};

Vue.use(VeeValidate, config);

Vue.config.productionTip = false;

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes,
  linkActiveClass: "active"
});

Vue.http.options.root = process.env.API_URL;

Vue.http.interceptors.push((request, next) => {
  const token = store.state.token;

  request.headers.set("Accept", "application/json");
  request.headers.set("Authorization", `Bearer ${token}`);

  request.url +=
    (request.url.indexOf("?") > 0 ? "&" : "?") + `cb=${new Date().getTime()}`;
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    store.commit("initialiseStore");
    const context = {
      from,
      next,
      router,
      to,
      store
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: socketio(process.env.API_URL, connectionOptions),
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_"
    }
  })
);

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    Vue,
    dsn:
      "https://e711d1ed2ad242639c8b031f8ffd047d@o135686.ingest.sentry.io/5563086",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    tracingOptions: {
      trackComponents: true
    },
    ignoreErrors: ["ResizeObserver loop limit exceeded"]
  });

  Vue.use(Hotjar, {
    id: "2275881"
  });
}

Vue.config.errorHandler = function(err, vm, info) {
  console.log(err);
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
};

new Vue({
  router,
  store,
  el: "#app",
  components: { App },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js